import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
export const ClaimerPreviewAgents = _ref => {
  let {
    aifReportData
  } = _ref;
  const {
    aif_model
  } = aifReportData;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-white"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Agents")), /*#__PURE__*/React.createElement(Card.Body, null, aif_model.agents.map((agent, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "mb-3 p-3 border rounded"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Name:"), " ", agent.name.first_name, " ", agent.name.last_name), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Email:"), " ", agent.email), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Phone:"), " ", agent.phone || 'Not provided'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Type:"), " ", /*#__PURE__*/React.createElement(Badge, {
    bg: "primary"
  }, agent.agent_type.toUpperCase()))), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Company:"), " ", agent.company.name), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Address:")), /*#__PURE__*/React.createElement("div", {
    className: "ms-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, agent.company.address.line1), agent.company.address.line2 && /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, agent.company.address.line2), /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, agent.company.address.town_city), /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, agent.company.address.postcode))))))));
};